import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

import { ModalController, IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-pass-entry',
  templateUrl: './pass-entry.page.html',
  styleUrls: ['./pass-entry.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonicModule, FormsModule, TranslatePipe],
})
export class PassEntryPage implements AfterViewInit {
  private modalController = inject(ModalController);

  @ViewChild('passInput', { static: true }) passInput: ElementRef;

  timeout = null;
  passId = '';

  async passScanned() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(async () => {
      await this.modalController.dismiss(this.passId, 'submit', 'passInfoModal');
    }, 500);
  }

  async dismiss() {
    await this.modalController.dismiss(null, 'cancel', 'passInfoModal');
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.passInput?.nativeElement?.focus();
    }, 500);
  }
}
